const motionQuery = matchMedia('(prefers-reduced-motion)');

export function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

export function setCookie(name, value, days) {
  var d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

// function deleteCookie(name) { setCookie(name, '', -1); }


/**
 * Check for "Prefers reduced motion"
 * ==================================
 */
let disableMotion = false;

function reducedMotionCheck() {
  disableMotion = motionQuery.matches;
}

reducedMotionCheck();
motionQuery.addListener(reducedMotionCheck);

/* ================================== */


/**
 * Check if video is playing
 * @param {object} video video element
 */
function isVideoPlaying(video) {
  return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
}

/**
 * Set state toggle related attributes
 * @param {object} btn button element to taget
 * @param {object} vidParent the element that wraps the video
 * @param {string} label the label added to the button's aria-label attribute
 * @param {string} addClass class added to button and vidParent
 * @param {string} removeClass class removed from button and vidParent
 */
function stateSetAttributes(btn, vidParent, label, addClass, removeClass) {
  btn.setAttribute('aria-label', label);
  btn.classList.add(addClass);
  btn.classList.remove(removeClass);
  vidParent.classList.add(addClass);
  vidParent.classList.remove(removeClass);
}



/**
 * Set state to Play
 * @param {object} btn button element
 * @param {object} vid video element
 * @param {object} vidParent element that wraps the video
 */
function stateToPlay(btn, vid, vidParent) {
  const label = btn.getAttribute('data-pauselabel') ? btn.getAttribute('data-pauselabel') : 'Pause';
  stateSetAttributes(btn, vidParent, label, 'o-ambient-video--is-playing', 'o-ambient-video--is-paused');
  setCookie('BC_Ambient_Video_Opt', 'play', 1);
  vid.play();
  return;
}



/**
 * Set state to Pause
 * @param {object} btn button element
 * @param {object} vid video element
 * @param {object} vidParent element that wraps the video
 */
function stateToPause(btn, vid, vidParent) {
  const label = btn.getAttribute('data-playlabel') ? btn.getAttribute('data-pauselabel') : 'Play';
  stateSetAttributes(btn, vidParent, label, 'o-ambient-video--is-paused', 'o-ambient-video--is-playing');
  setCookie('BC_Ambient_Video_Opt', 'pause', 1);
  vid.pause();
}



/**
 * Video state toggle handler
 * @param {object} btn button element that was clicked
 */
function stateToggleHandler(btn) {
  const vidParent = btn.closest('.js-video-parent');

  if (vidParent) {
    const vid = vidParent.querySelector('video');

    if (!vid) {
      return;
    }

    const isPlaying = isVideoPlaying(vid);

    if (isPlaying) {
      stateToPause(btn, vid, vidParent);
    } else {
      stateToPlay(btn, vid, vidParent);
    }

  }
}

function initVideoStateToggle() {
  const vidToggleBtns = document.querySelectorAll('.js-video-toggle');

  [].forEach.call(vidToggleBtns, (btn) => {
    btn.addEventListener('click', () => {
      stateToggleHandler(btn)
    });
  });
}



export default function initAmbientVideo() {
  const ambientVideos = document.querySelectorAll('.o-ambient-video');

  if ( !ambientVideos ) return;

  initVideoStateToggle();

  [].forEach.call(ambientVideos, (av) => {
    const vid = av.querySelector('video');
    // const poster = av.querySelector('img');
    const stateBtn = av.querySelector('.js-video-toggle');


    // Play vid
    if ( disableMotion ) {
      av.classList.add('o-ambient-video--no-motion');
    } else if ( vid ) {

      // If the poster is set to display
      // if (poster.length && poster.offsetParent !== null) {
      //   av.classList.add('o-ambient-video--video-hidden');
      // } else {

        av.classList.add('o-ambient-video--loading');
        let listenerInitiated = false;

        // Play video when it can play
        vid.addEventListener('loadeddata', function readyStateWatcher() {
          if (!listenerInitiated && vid.readyState >= 2) {
            listenerInitiated = true;
            av.classList.remove('o-ambient-video--loading');
            av.classList.add('o-ambient-video--is-ready');
            const cookieOptSetting = getCookie('BC_Ambient_Video_Opt');

            if ( cookieOptSetting === 'pause' ) {
              vid.pause();
            } else {
              vid.play();
            }

            setTimeout(() => {
              av.classList.add('o-ambient-video--can-animate');
            }, 1);

            if (stateBtn) {
              if ( cookieOptSetting === 'pause' ) {
                stateToPause(stateBtn, vid, av);
              } else {
                stateToPlay(stateBtn, vid, av);
              }
            }

            // Remove the eventlistener
            vid.removeEventListener( 'loadeddata', readyStateWatcher(), false );
          }
        }, false);

        // Handle errors
        vid.addEventListener('error', (event) => {
          av.classList.add('o-ambient-video--video-error');
          console.log(event);
        }, true);
      // }

    }

  });
}

